import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import { controller } from '../../core/controller/controller.js';
import { OneTrustContextInitialValues, OneTrustContext } from './context.js';

const OneTrustProvider = ({ children, performanceCookies })=>{
    const [values, setValues] = useState(OneTrustContextInitialValues);
    const initOneTrust = useCallback(()=>{
        // Determine if the performance category is opt-in
        if (!controller.hasPerformanceCategory()) {
            // Clear performance cookies
            controller.clearPerformanceCookies(performanceCookies);
        }
        // Set Initialization Values
        setValues((prev)=>({
                ...prev,
                initialized: true,
                hasPerformance: controller.hasPerformanceCategory(),
                hasFunctional: controller.hasFunctionalCategory(),
                hasTargeting: controller.hasTargetingCategory()
            }));
        // Snapshot current active groups and reload only when privacy choices change
        controller.snapshotCurrentActiveGroup();
    }, [
        performanceCookies
    ]);
    useEffect(()=>{
        const handler = async ()=>{
            if (await controller.isInitialized()) {
                initOneTrust();
            }
            setValues((prev)=>({
                    ...prev,
                    loading: false
                }));
        };
        void handler();
    }, [
        initOneTrust
    ]);
    return jsx(OneTrustContext.Provider, {
        value: values,
        children: children
    });
};

export { OneTrustProvider };
//# sourceMappingURL=provider.js.map
